export default function Configure($stateProvider) {
    $stateProvider.state('societes', {
        parent: 'common',
        url: '/societes',
        views: {
            common: {
                template: '<ui-view></ui-view>'
            }
        },
        ncyBreadcrumb: {
            label: '{{ "LAYOUT.NAVIGATION.DONNEES_PARAMETRES" | translate }}'
        }
    });

    $stateProvider.state('societes.list', {
        url: '/list',
        template: '<societes></societes>',
        rights: { domain: 'societes', right: 'read', application: 'gestion' },
        params: {
            genre: '1'
        },
        ncyBreadcrumb: {
            label: '{{ "SOCIETES.BREADCRUMBS.SOCIETES_COMMERCIAL_LIST" | translate}}'
        },
        navigation: {
            menu: 'donnees_parametres_donnees',
            translate: 'SOCIETES.BREADCRUMBS.SOCIETES_COMMERCIAL_LIST',
            order: 1
        },
        search: 'SOCIETES.BREADCRUMBS.SOCIETES_COMMERCIAL_LIST'
    });

    $stateProvider.state('societes.niveaux', {
        url: '/niveaux',
        template: '<societe-config-niveaux></societe-config-niveaux>',
        rights: { domain: 'nivh', right: 'read' },
        params: {
            genre: '1'
        },
        ncyBreadcrumb: {
            // on décide que la liste est le parent des autres states
            // afin d'afficher societes > niveaux
            parent: 'societes.list({genre: "1"})',
            label: '{{ "SOCIETES.BREADCRUMBS.SOCIETE_NIVEAUX" | translate }}'
        }
    });

    $stateProvider.state('societes.list.detail', {
        url: '/{id}',
        template: '<societe-detail></societe-detail>',
        rights: { domain: 'societes', right: 'read' },
        params: {
            genre: '1'
        },
        ncyBreadcrumb: {
            parent: 'societes.list({genre: "1"})',
            label: '{{ "SOCIETES.BREADCRUMBS.SOCIETE_DETAIL" | translate }}'
        }
    });

    $stateProvider.state('societes.new', {
        url: '/new',
        template: '<societe-form></societe-form>',
        rights: { domain: 'societes', right: 'create' },
        params: {
            genre: '1'
        },
        ncyBreadcrumb: {
            parent: 'societes.list({genre: "1"})',
            label: '{{ "SOCIETES.BREADCRUMBS.SOCIETE_COMMERCIAL_NEW" | translate}}'
        },
        search: 'SOCIETES.BREADCRUMBS.SOCIETE_COMMERCIAL_NEW'
    });

    $stateProvider.state('societes.edit', {
        url: '/{id}/edit',
        template: '<societe-form></societe-form>',
        rights: { domain: 'societes', right: 'update' },
        params: {
            genre: '1'
        },
        ncyBreadcrumb: {
            parent: 'societes.list({genre: "1"})',
            label: '{{ "SOCIETES.BREADCRUMBS.SOCIETE_COMMERCIAL_EDIT" | translate }}'
        }
    });

    $stateProvider.state('societes.newType', {
        url: '/new-type',
        template: '<type-form></type-form>',
        rights: { domain: 'types', right: 'create' },
        params: {
            parentState: 'societes.new',
            genre: '1'
        },
        ncyBreadcrumb: {
            parent: 'societes.new',
            label: '{{ "TYPES.BREADCRUMBS.TYPE_NEW" | translate}}'
        }
    });
}

Configure.$inject = ['$stateProvider'];
